import React from 'react'
import ContextualMenu from 'components/graph/controls/contextualMenu'
import Generate from 'components/graph/controls/generate'
import Ask from 'components/graph/controls/ask'
import Clear from 'components/graph/controls/clear'

type ContentMenuProps = {
  open: boolean
  onCollapse: () => void
  onWidthChange?: ((width: number) => void) | undefined
  isFetchingAny: boolean
  isFailed?: boolean | undefined
  hasFocus: boolean
  onGenerate: () => void
  onAsk: () => void
  onClear: () => void
}

const ContentMenu = ({
  open,
  onCollapse,
  onWidthChange,
  isFetchingAny,
  isFailed,
  hasFocus,
  onGenerate,
  onAsk,
  onClear,
}: ContentMenuProps) => {
  return (
    <ContextualMenu open={open} onCollapse={onCollapse} onWidthChange={onWidthChange}>
      <Generate onClick={onGenerate} isFetching={isFetchingAny} isFailed={isFailed} />
      {hasFocus ? <Ask onClick={onAsk} isFetching={isFetchingAny} /> : null}
      <Clear onClick={onClear} />
    </ContextualMenu>
  )
}

export default ContentMenu
